import React from "react";
import PropTypes from "prop-types";
import { defaultTemplate } from "core/hoc";
import { BasicTextArea, BaasicFormControls, BaasicButton } from "core/components";
import { Content } from "core/layouts";

const NoteEditModalTemplate = function({ noteEditModalStore, componentProps }) {
    const {
        contentLoading,
        form
    } = noteEditModalStore;

    return (
        <form onSubmit={form.onSubmit}>
            <div className="modal__header">
                <h2 className="modal__header__title"> {componentProps.modalParams.data.isEdit ? 'Edit' : 'Add'} Note </h2>
            </div>
            
            <div className="modal__body">
                <Content loading={contentLoading}>
                    <BasicTextArea field={form.$('note')} />
                </Content>
            </div>

            <div className="modal__footer">
                <BaasicFormControls form={form} onSubmit={form.onSubmit} disabled={form.submitting} className='btn btn--med btn--primary'/>
                <BaasicButton
                    className='btn btn--med btn--light'
                    label='EDIT_FORM_LAYOUT.CANCEL'
                    onClick={() => componentProps.modalParams.close()}
                />
            </div>
        </form>
    );
};

NoteEditModalTemplate.propTypes = {
    noteEditModalStore: PropTypes.object.isRequired,
    componentProps: PropTypes.object
};

export default defaultTemplate(NoteEditModalTemplate);